import React, { useId } from 'react';

// Flame geometry from the Prometheus app icon, drawn in the site palette:
// violet, iris, lilac and porcelain.
const FLAME =
  'M29.53 7.04 C29.57 7.02 29.63 6.99 29.74 7.04 C29.84 7.09 29.69 6.91 30.14 7.34 C30.59 7.78 31.83 8.99 32.45 9.66 C33.07 10.33 33.31 10.60 33.86 11.37 C34.42 12.14 35.15 13.16 35.77 14.29 C36.39 15.41 37.08 16.77 37.59 18.11 C38.09 19.45 38.53 21.16 38.79 22.34 C39.06 23.51 39.11 24.18 39.20 25.16 C39.28 26.13 39.30 27.66 39.30 28.18 C39.30 28.70 39.21 28.02 39.20 28.28 C39.18 28.53 39.26 29.10 39.20 29.69 C39.13 30.27 38.86 31.35 38.79 31.80 C38.73 32.25 38.68 32.29 38.79 32.40 C38.91 32.52 39.15 32.79 39.50 32.50 C39.85 32.22 40.52 31.35 40.91 30.69 C41.29 30.04 41.63 29.10 41.81 28.58 C42.00 28.06 41.98 28.02 42.01 27.57 C42.05 27.12 41.98 26.15 42.01 25.86 C42.05 25.58 42.03 25.63 42.22 25.86 C42.40 26.10 42.79 26.67 43.12 27.27 C43.46 27.87 43.91 28.78 44.23 29.48 C44.55 30.19 44.78 30.76 45.03 31.50 C45.29 32.23 45.52 32.87 45.74 33.91 C45.96 34.95 46.24 36.53 46.34 37.74 C46.44 38.94 46.36 40.57 46.34 41.16 C46.33 41.75 46.29 40.87 46.24 41.26 C46.19 41.65 46.21 42.60 46.04 43.47 C45.87 44.35 45.60 45.47 45.23 46.49 C44.87 47.52 44.33 48.71 43.83 49.61 C43.32 50.52 42.84 51.19 42.22 51.93 C41.59 52.67 40.74 53.49 40.10 54.04 C39.46 54.59 39.06 54.86 38.39 55.25 C37.72 55.63 36.93 56.07 36.08 56.36 C35.22 56.64 34.11 56.86 33.26 56.96 C32.40 57.06 31.60 57.01 30.94 56.96 C30.29 56.91 29.92 56.83 29.33 56.66 C28.75 56.49 28.01 56.22 27.42 55.95 C26.83 55.69 26.36 55.42 25.81 55.05 C25.26 54.68 24.75 54.34 24.10 53.74 C23.45 53.14 22.54 52.23 21.89 51.42 C21.23 50.62 20.71 49.88 20.17 48.91 C19.64 47.94 19.00 46.43 18.66 45.59 C18.33 44.75 18.31 44.53 18.16 43.88 C18.01 43.22 17.84 42.67 17.76 41.66 C17.67 40.66 17.59 39.03 17.66 37.84 C17.73 36.65 17.93 35.56 18.16 34.52 C18.40 33.48 18.70 32.55 19.07 31.60 C19.44 30.64 19.81 29.80 20.38 28.78 C20.95 27.76 21.72 26.55 22.49 25.46 C23.26 24.37 24.25 23.26 25.01 22.24 C25.76 21.21 26.41 20.31 27.02 19.32 C27.62 18.33 28.24 17.14 28.63 16.30 C29.01 15.46 29.13 15.07 29.33 14.29 C29.53 13.50 29.75 12.47 29.84 11.57 C29.92 10.66 29.89 9.59 29.84 8.85 C29.79 8.11 29.58 7.44 29.53 7.14 C29.48 6.84 29.50 7.06 29.53 7.04 Z';
const CORE =
  'M32.16 16.06 C32.24 16.10 32.33 16.04 32.56 16.31 C32.79 16.59 33.13 17.01 33.56 17.71 C33.99 18.41 34.64 19.47 35.13 20.53 C35.61 21.58 36.13 22.94 36.47 24.05 C36.82 25.16 37.02 26.33 37.17 27.17 C37.32 28.01 37.37 28.13 37.38 29.08 C37.39 30.04 37.35 31.90 37.24 32.91 C37.13 33.91 37.04 34.18 36.71 35.12 C36.38 36.06 35.55 37.64 35.25 38.54 C34.94 39.45 34.88 39.83 34.88 40.55 C34.87 41.28 34.95 41.94 35.24 42.87 C35.53 43.80 37.37 46.31 36.62 46.13 C35.87 45.94 32.12 42.86 30.74 41.78 C29.36 40.70 29.04 40.42 28.33 39.65 C27.62 38.87 26.97 38.01 26.48 37.13 C26.00 36.26 25.65 34.85 25.40 34.40 C25.15 33.94 25.15 34.24 25.00 34.40 C24.85 34.55 24.49 35.55 24.49 35.32 C24.48 35.09 24.75 33.76 24.98 33.01 C25.21 32.25 25.06 32.25 25.89 30.79 C26.71 29.33 29.06 25.74 29.93 24.25 C30.81 22.76 30.80 22.66 31.12 21.83 C31.44 21.01 31.69 20.27 31.86 19.32 C32.02 18.36 32.07 16.64 32.12 16.10 C32.18 15.56 32.09 16.03 32.16 16.06 Z';
const EMBER =
  'M25.16 34.21 C25.20 34.21 25.17 33.79 25.37 34.26 C25.56 34.73 25.88 36.17 26.32 37.03 C26.77 37.90 27.33 38.67 28.04 39.45 C28.74 40.23 29.22 40.66 30.54 41.72 C31.86 42.78 34.77 44.75 35.98 45.80 C37.18 46.85 37.31 47.23 37.76 48.02 C38.20 48.80 38.50 49.77 38.65 50.52 C38.80 51.27 38.76 51.91 38.69 52.53 C38.61 53.15 38.43 53.73 38.21 54.24 C37.98 54.76 37.80 55.26 37.36 55.62 C36.92 55.98 36.19 56.22 35.57 56.42 C34.96 56.63 34.30 56.75 33.66 56.83 C33.02 56.92 32.35 56.97 31.75 56.96 C31.14 56.94 30.59 56.85 30.04 56.74 C29.48 56.62 29.05 56.52 28.43 56.28 C27.81 56.03 26.92 55.61 26.31 55.27 C25.71 54.92 25.28 54.60 24.80 54.22 C24.33 53.83 23.67 53.20 23.45 52.94 C23.22 52.68 23.15 52.80 23.45 52.68 C23.74 52.55 24.75 52.41 25.21 52.19 C25.66 51.96 25.90 51.69 26.19 51.32 C26.48 50.96 26.76 50.50 26.95 50.02 C27.13 49.53 27.29 49.08 27.31 48.41 C27.32 47.73 27.39 47.06 27.03 45.99 C26.67 44.92 25.56 42.97 25.15 41.96 C24.73 40.96 24.67 40.72 24.53 39.95 C24.39 39.18 24.31 38.01 24.31 37.33 C24.32 36.66 24.42 36.44 24.55 35.93 C24.68 35.41 25.00 34.55 25.10 34.26 C25.20 33.97 25.11 34.21 25.16 34.21 Z';

/* The app icon: flame on a round ground. With ground={false} the flame stands alone,
   filled with a gradient, for large decorative use. */
export function Flame({ className = '', ground = true }) {
  const id = `flame-${useId().replace(/:/g, '')}`;
  return (
    <svg className={`flame ${className}`.trim()} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      {ground ? <circle cx="32" cy="32" r="30.5" fill="none" stroke="currentColor" strokeWidth="1.25" /> : null}
      {ground ? null : (
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#c9bdf5" />
            <stop offset="0.55" stopColor="#8b7dff" />
            <stop offset="1" stopColor="#7154d8" />
          </linearGradient>
        </defs>
      )}
      <g transform="matrix(1.15 0 0 1 -4.8 0)">
        <path fill={ground ? '#7154d8' : `url(#${id})`} d={FLAME} />
        <path fill="#f6f5f1" d={CORE} />
        <path fill="#c9bdf5" d={EMBER} />
      </g>
    </svg>
  );
}

const glyph = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
};

const GLYPHS = {
  voice: <path d="M4 10v4M8 7v10M12 4v16M16 7v10M20 10v4" />,
  markets: <path d="M3 17.5 8.5 12l4 3.2L20.5 7M15.5 7h5v5" />,
  google: <path d="M3.5 6h17v12h-17zM3.5 7l8.5 6 8.5-6" />,
  browser: <path d="M3.5 5h17v14h-17zM3.5 9h17M6.5 7h.01M9 7h.01M10 13l6 2.4-2.6 1-1 2.6z" />,
  desktop: <path d="M3.5 4.5h17v11h-17zM9 19.5h6M12 15.5v4" />,
  memory: <path d="M6.5 3.5h11v17L12 16.5l-5.5 4z" />,
  search: <path d="M10.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM15.5 15.5 20.5 20.5" />,
  files: <path d="M6.5 3.5h7.5l4 4v13h-11.5zM14 3.5v4h4M9.5 12h5M9.5 15.5h5" />,
  subagents: (
    <>
      <circle cx="12" cy="5.5" r="2" />
      <circle cx="5.5" cy="18" r="2" />
      <circle cx="18.5" cy="18" r="2" />
      <path d="M11 7.3 6.5 16.2M13 7.3l4.5 8.9M7.5 18h9" />
    </>
  ),
  plugins: <path d="M9 3.5V8M15 3.5V8M6.5 8h11v3.5a5.5 5.5 0 0 1-11 0zM12 17v3.5" />,
  terminal: <path d="M3.5 5h17v14h-17zM7 9.5l3 2.5-3 2.5M12.5 15h4.5" />,
};

export function Glyph({ name, className = 'pm-glyph' }) {
  return (
    <svg {...glyph} className={className}>
      {GLYPHS[name]}
    </svg>
  );
}

/* Decorative voice meter: a speech-shaped envelope, each bar on its own beat. */
export function Waveform() {
  const n = 16;
  return (
    <div className="pm-wave" aria-hidden="true">
      {Array.from({ length: n }, (_, i) => {
        const t = i / (n - 1);
        const envelope = Math.sin(Math.PI * t);
        const h = 18 + envelope * 72 + ((i * 17) % 11);
        const duration = 0.9 + ((i * 0.137) % 0.7);
        const delay = -((i * 0.19) % 1.6);
        return (
          <span
            key={i}
            style={{
              '--h': `${Math.round(h)}%`,
              '--dur': `${duration.toFixed(2)}s`,
              '--delay': `${delay.toFixed(2)}s`,
            }}
          />
        );
      })}
    </div>
  );
}

/* Two illustrative price lines. They are not data and carry no values. */
export function PriceLines() {
  const a = 'M0 98 C40 92 64 77 104 76 S168 58 208 49 S272 31 320 20';
  const b = 'M0 104 C48 101 84 91 124 87 S192 73 232 66 S284 54 320 47';
  return (
    <svg className="pm-lines" viewBox="0 0 320 120" preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <path className="pm-lines__grid" d="M0 30H320M0 60H320M0 90H320" />
      <path className="pm-lines__area" d={`${a} L320 120 L0 120 Z`} />
      <path className="pm-lines__b" d={b} />
      <path className="pm-lines__a" d={a} />
    </svg>
  );
}
